
export const AUTH_URL = '/oauth/token';

export const USER_URL = '/api/user';
export const USER_LIST_URL = '/api/user/list';
export const RECOMMENDATION_URL = 'api/recommendations'
export const PUBLIC_RECOMMENDATION_URL = 'api/public/recommendations'
export const INSTITUTION_URL = 'api/institutions'
export const COMPETENT_AUTHORITIES = 'api/competent-authorities'
export const AUTH_URL_MAGIC_LINK = 'api/user/magic-link-token';
export const ROLE_LIST = '/api/roles/list';
export const DASHBOARD = '/api/dashboard';
